import React, { useState, useEffect } from "react";
import { X } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import PageHero from "../components/PageHero";
import Reveal from "../components/Reveal";
import { galleryImages } from "../mock/mock";

const Gallery = () => {
  const { t } = useLang();
  const [active, setActive] = useState(null);

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && setActive(null);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <div>
      <PageHero
        image="https://images.unsplash.com/photo-1459908676235-d5f02a50184b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwyfHxhcnQlMjBzdHVkaW98ZW58MHx8fHwxNzgzNjcyMjgzfDA&ixlib=rb-4.1.0&q=85"
        kicker="arts4all"
        title={t("gallery.title")}
        lead={t("gallery.lead")}
      />

      <section className="bg-[#faf7f2] py-20 lg:py-28">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <div className="columns-2 md:columns-3 gap-4 [column-fill:_balance]">
            {galleryImages.map((src, i) => (
              <Reveal
                key={i}
                delay={(i % 3) * 80}
                className="mb-4 break-inside-avoid"
              >
                <button
                  onClick={() => setActive(src)}
                  className="group block w-full overflow-hidden bg-[#eae4d9]"
                >
                  <img
                    src={src}
                    alt={`gallery ${i + 1}`}
                    loading="lazy"
                    className="w-full object-cover transition-transform duration-[1200ms] group-hover:scale-105"
                  />
                </button>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox */}
      {active && (
        <div
          className="fixed inset-0 z-[60] bg-black/90 flex items-center justify-center p-4 animate-[fadeIn_0.3s_ease]"
          onClick={() => setActive(null)}
        >
          <button
            className="absolute top-6 right-6 text-white/80 hover:text-white"
            onClick={() => setActive(null)}
            aria-label="Close"
          >
            <X className="w-8 h-8" />
          </button>
          <img
            src={active}
            alt="preview"
            className="max-h-[88vh] max-w-[92vw] object-contain"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
};

export default Gallery;
